import logo from './logo.svg';
import React, { useEffect, useState } from 'react';
import './App.css';

function App() {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = () => {
      fetch('https://myiot-5a297-default-rtdb.asia-southeast1.firebasedatabase.app/.json?orderBy=%22$key%22&startAt=%22master%22&endAt=%22master\\uf8ff%22')
        .then(response => response.json())
        .then(data => setData(data ? Object.values(data) : []))
        .catch(error => console.error('Error fetching data:', error));
    };

    fetchData();
    const intervalId = setInterval(fetchData, 5000); // Fetch data every 5 seconds

    return () => clearInterval(intervalId); // Cleanup interval on component unmount
  }, []);

  return (
    <div className="App">
      <header className="App-header" style={{ backgroundColor: '#00AA13', padding: '20px', color: 'white' }}>
        <button 
          onClick={() => document.getElementById('drawer').style.width = '250px'} 
          style={{ 
            backgroundColor: 'white', 
            color: '#00AA13', 
            border: 'none', 
            padding: '10px 20px', 
            borderRadius: '5px', 
            cursor: 'pointer' 
          }}
        >
          Menu
        </button>
        <h1 style={{ fontFamily: 'Arial, sans-serif' }}>Data List</h1>
        <div style={{ overflowX: 'auto' }}>
          <ul style={{ listStyleType: 'none', padding: 0 }}>
            {data.map((item, index) => (
              <li key={index} style={{ border: '1px solid #00AA13', padding: '10px', marginBottom: '10px', backgroundColor: 'white', color: '#00AA13' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  {Object.entries(item).map(([key, value], idx) => (
                    key !== 'am' && key !== 'lokasi' && key !== 'nama' && key !== 'nama_alatberat' && (
                      <div key={idx} style={{ flex: 1, padding: '10px', backgroundColor: key === 'img' ? 'red' : 'transparent' }}>
                        {key === 'img' || key === 'photo' ? (
                          <img src={value} alt="img" style={{ width: '100px', height: 'auto' }} />
                        ) : key === 'suhumesin' ? (
                          <span style={{ color: value > 150 ? 'red' : 'blue' }}>{value}</span>
                        ) : (
                          typeof value === 'object' ? JSON.stringify(value) : value
                        )}
                      </div>
                    )
                  ))}
                  <div style={{ flex: 1, padding: '10px' }}>
                    {`${item.am || ''} ${item.lokasi || ''} ${item.nama || ''} ${item.nama_alatberat || ''}`}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </header>
      <div id="drawer" style={{ height: '100%', width: '0', position: 'fixed', zIndex: '1', top: '0', left: '0', backgroundColor: '#111', overflowX: 'hidden', transition: '0.5s', paddingTop: '60px' }}>
        <a href="javascript:void(0)" style={{ position: 'absolute', top: '20px', right: '25px', fontSize: '36px', marginLeft: '50px', color: 'white', textDecoration: 'none' }} onClick={() => document.getElementById('drawer').style.width = '0'}>&times;</a>
        <a href="#" style={{ padding: '8px 8px 8px 32px', textDecoration: 'none', fontSize: '25px', color: '#818181', display: 'block', transition: '0.3s' }}>Link 1</a>
        <a href="#" style={{ padding: '8px 8px 8px 32px', textDecoration: 'none', fontSize: '25px', color: '#818181', display: 'block', transition: '0.3s' }}>Link 2</a>
        <a href="#" style={{ padding: '8px 8px 8px 32px', textDecoration: 'none', fontSize: '25px', color: '#818181', display: 'block', transition: '0.3s' }}>Link 3</a>
        <a href="#" style={{ padding: '8px 8px 8px 32px', textDecoration: 'none', fontSize: '25px', color: '#818181', display: 'block', transition: '0.3s' }}>Link 4</a>
      </div>
    </div>
  );
}

export default App;
